import "./Service.css";
import { Link } from "react-router-dom";
import { getRoutePaths, useLang } from "../../../utils/i18n";

const Service = () => {
  const lang = useLang();
  const paths = getRoutePaths(lang);
  const copy = {
    en: {
      heading: "Services",
      lead: "Strategic finance, built around the decisions that matter.",
      intro:
        "From financial planning and performance to leadership, systems and expansion, Monetique helps businesses turn complexity into clarity — and clarity into action.",
      s1Title: "Strategic Finance & Performance",
      s1Text:
        "Turning complex financial data into clearer forecasts, sharper decisions and stronger performance.",
      s2Title: "Business Partnering & Strategy",
      s2Text:
        "Helping leadership teams align finance, people and strategy around better decisions.",
      s3Title: "Finance Technology & Transformation",
      s3Text:
        "Using AI, automation and cloud systems to make finance faster, smarter and more scalable.",
      s4Title: "Global Advisory & Expansion",
      s4Text:
        "Supporting international growth with financial, operational and cross-border expertise.",
      ctaTitle: "Build a finance function ready for what’s next.",
      ctaText: "Let’s turn your next financial challenge into a clear path forward.",
      ctaButton: "Contact",
    },
    pt: {
      heading: "Nossos Serviços em Destaque",
      lead: "Finanças estratégicas, construídas em torno das decisões que realmente importam.",
      intro:
        "Do planejamento financeiro e performance à liderança, sistemas e expansão, a Monetique ajuda empresas a transformar complexidade em clareza — e clareza em ação.",
      s1Title: "Finanças Estratégicas & Performance",
      s1Text:
        "Transformamos dados financeiros complexos em previsões mais claras, decisões mais precisas e melhor performance.",
      s2Title: "Business Partnering & Estratégia",
      s2Text:
        "Ajudamos lideranças a alinhar finanças, pessoas e estratégia em torno de decisões melhores.",
      s3Title: "Tecnologia Financeira & Transformação",
      s3Text:
        "Usamos IA, automação e sistemas em nuvem para tornar as finanças mais ágeis, inteligentes e escaláveis.",
      s4Title: "Consultoria Global & Expansão",
      s4Text:
        "Apoiamos o crescimento internacional com expertise financeira, operacional e transfronteiriça.",
      ctaTitle: "Construa uma área financeira pronta para o próximo passo.",
      ctaText: "Vamos transformar seu próximo desafio financeiro em um caminho claro para avançar.",
      ctaButton: "Contato",
    },
  };

  const featuredServices = [
    { title: copy[lang].s1Title, text: copy[lang].s1Text },
    { title: copy[lang].s2Title, text: copy[lang].s2Text },
    { title: copy[lang].s3Title, text: copy[lang].s3Text },
    { title: copy[lang].s4Title, text: copy[lang].s4Text },
  ];

  return (
    <section className="our-services">
      <div className="service-hero">
        <h1 className="main-heading">{copy[lang].heading}</h1>
        <div className="service-description">
          <h2 className="service-lead">{copy[lang].lead}</h2>
          <p>{copy[lang].intro}</p>
        </div>
      </div>
      <header className="services-header">
        <h2 className="services-header-title">
          {lang === "en" ? "Where we create value" : "Onde criamos valor"}
        </h2>
      </header>
      <section
        className="services-grid"
        aria-label={lang === "en" ? "Services" : "Serviços em destaque"}
      >
        {featuredServices.map((item, index) => (
          <article className="service-feature" key={item.title}>
            <span className="service-feature-index">{`0${index + 1}`}</span>
            <h2 className="service-feature-title">{item.title}</h2>
            <p className="service-feature-text">{item.text}</p>
          </article>
        ))}
      </section>

      <section className="service-note">
        <div className="service-note-heading">
          <p className="service-note-kicker">
            {lang === "en" ? "Start the Conversation" : "Inicie a Conversa"}
          </p>
          <h2>{copy[lang].ctaTitle}</h2>
        </div>
        <div className="service-note-content">
          <p className="service-note-text">{copy[lang].ctaText}</p>
          <Link className="service-cta-button" to={paths.contact}>
            {copy[lang].ctaButton}
          </Link>
        </div>
      </section>
    </section>
  );
};

export default Service;
